/**
 * Query params for `GET /branches/list` and `GET /branches/details`. Mirrors
 * the bos-api `BranchesListQuery`: 1-based `page`, `pageSize` (capped at
 * {@link BRANCH_LIST_MAX_PAGE_SIZE} server-side), and an optional
 * case-insensitive `search` over name + address. The API orders results
 * main-branch-first then by name; there is no sort parameter.
 */
export type BranchListQuery = {
    page: number;
    pageSize: number;
    search?: string;
    /**
     * Reveal archived branches, which the server hides by default (BOS-121).
     * Their sales stay in branch comparison for the ranges they traded in
     * regardless — this only controls the management list.
     */
    includeArchived?: boolean;
};

/** Largest `pageSize` the bos-api honours (`BranchesListQuery.MaxPageSize`). */
export const BRANCH_LIST_MAX_PAGE_SIZE = 200;
